export * from './lib/external-link-directive.module';

export { AccredibleExternalLinkDirective } from './lib/external-link.directive';
